var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUndo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 122,
    height: 116,
    viewBox: "0 0 122 116",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_di_1963_45175)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 26,
    width: 62,
    height: 46,
    rx: 6,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.792 47.18V41.6H47.908V47.132C47.908 47.732 48.084 48.204 48.436 48.548C48.796 48.892 49.3 49.064 49.948 49.064C50.596 49.064 51.096 48.892 51.448 48.548C51.808 48.204 51.988 47.732 51.988 47.132V41.6H53.092V47.18C53.092 48.092 52.8 48.816 52.216 49.352C51.632 49.888 50.876 50.156 49.948 50.156C49.012 50.156 48.252 49.888 47.668 49.352C47.084 48.816 46.792 48.092 46.792 47.18ZM57.7072 43.844C58.4112 43.844 58.9752 44.068 59.3992 44.516C59.8232 44.956 60.0352 45.556 60.0352 46.316V50H58.9912V46.376C58.9912 45.896 58.8592 45.52 58.5952 45.248C58.3312 44.976 57.9672 44.84 57.5032 44.84C56.9672 44.84 56.5432 45.008 56.2312 45.344C55.9192 45.672 55.7632 46.164 55.7632 46.82V50H54.7192V44H55.7632V44.864C56.1792 44.184 56.8272 43.844 57.7072 43.844ZM66.4895 45.032V41.6H67.5335V50H66.4895V48.968C65.9775 49.76 65.2215 50.156 64.2215 50.156C63.3735 50.156 62.6575 49.852 62.0735 49.244C61.4815 48.628 61.1855 47.88 61.1855 47C61.1855 46.128 61.4815 45.384 62.0735 44.768C62.6655 44.152 63.3815 43.844 64.2215 43.844C65.2215 43.844 65.9775 44.24 66.4895 45.032ZM64.3535 49.148C64.9615 49.148 65.4695 48.944 65.8775 48.536C66.2855 48.112 66.4895 47.6 66.4895 47C66.4895 46.392 66.2855 45.884 65.8775 45.476C65.4695 45.06 64.9615 44.852 64.3535 44.852C63.7535 44.852 63.2495 45.06 62.8415 45.476C62.4335 45.884 62.2295 46.392 62.2295 47C62.2295 47.6 62.4335 48.112 62.8415 48.536C63.2495 48.944 63.7535 49.148 64.3535 49.148ZM74.208 49.244C73.6 49.852 72.852 50.156 71.964 50.156C71.076 50.156 70.328 49.852 69.72 49.244C69.112 48.636 68.808 47.888 68.808 47C68.808 46.112 69.112 45.364 69.72 44.756C70.328 44.148 71.076 43.844 71.964 43.844C72.852 43.844 73.6 44.148 74.208 44.756C74.824 45.372 75.132 46.12 75.132 47C75.132 47.88 74.824 48.628 74.208 49.244ZM71.964 49.136C72.564 49.136 73.068 48.932 73.476 48.524C73.884 48.116 74.088 47.608 74.088 47C74.088 46.392 73.884 45.884 73.476 45.476C73.068 45.068 72.564 44.864 71.964 44.864C71.372 44.864 70.872 45.068 70.464 45.476C70.056 45.884 69.852 46.392 69.852 47C69.852 47.608 70.056 48.116 70.464 48.524C70.872 48.932 71.372 49.136 71.964 49.136Z",
    fill: "#424242"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.0056 80.0064C53.8024 80.917 55.219 80.917 56.0159 80.0064L63.0214 72H46L53.0056 80.0064Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_di_1963_45175",
    x: 0,
    y: 0,
    width: 122,
    height: 115.727,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1963_45175"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1963_45175",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.6125 0 0 0 0 0.6125 0 0 0 0 0.6125 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_1963_45175"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndo);
export default __webpack_public_path__ + "static/media/undo.7f5988164219a4cbc9cc6ebff07cf859.svg";
export { ForwardRef as ReactComponent };